import {
  BriefcaseBusiness,
  Building,
  Building2,
  Car,
  Church,
  CircleDollarSign,
  Coffee,
  Dumbbell,
  Film,
  GraduationCap,
  HeartPulse,
  Hotel,
  Landmark,
  Map,
  Martini,
  Palette,
  ShoppingBag,
  ShoppingCart,
  TrainFront,
  Trees,
  Utensils,
  Wrench,
} from 'lucide-react';
import type { LucideIconComponent } from '@/src/components/LucideIcon';
import type { POIIconGroup } from './types';

export const POI_ICON_GROUP_ICONS: Record<POIIconGroup, LucideIconComponent> = {
  restaurants: Utensils,
  cafes: Coffee,
  groceries: ShoppingCart,
  shopping: ShoppingBag,
  nightlife: Martini,
  automotive: Car,
  business: BriefcaseBusiness,
  culture: Palette,
  education: GraduationCap,
  entertainment: Film,
  facilities: Building,
  finance: CircleDollarSign,
  foodDrink: Utensils,
  geographicalAreas: Map,
  government: Landmark,
  healthWellness: HeartPulse,
  housing: Building2,
  lodging: Hotel,
  naturalFeatures: Trees,
  worship: Church,
  services: Wrench,
  sportsFitness: Dumbbell,
  transportation: TrainFront,
};
